import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { MsgModel } from './../../common-components/msg/model/msg.model';
import { PostalCode } from './../../common-components/location/model/postal-code.model';
import { City } from './../../common-components/location/model/city.model';
import { AccountRequestService } from './../service/account-request.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, EmailValidator, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { AccountRequest } from 'src/app/component/auth/model/account-request/account-request.model';
import { Region } from '../../../model/region.model';
import { State } from '../../common-components/location/model/state.model';
import { AccountRequestSchoolDistrict } from '../model/account-request/account-request-school-district.model';
import { Organization } from '../../common-components/organizations/model/organization.model';
import { MatStepper } from '@angular/material/stepper';
import { DistrictComponent } from '../../common-components/district/district.component';

@Component({
    selector: 'app-account-request',
    templateUrl: './account-request.component.html',
    styleUrls: ['./account-request.component.scss']
})
export class AccountRequestComponent implements OnInit {
    @ViewChild(DistrictComponent) child!: DistrictComponent;
    personalInfoForm!: UntypedFormGroup;
    locationForm!: UntypedFormGroup;
    supervisorForm!: UntypedFormGroup;
    isLoading: boolean = false;
    accountRequest: AccountRequest;
    selectedMepOrganization: Organization;
    selectedNonMepOrganization: Organization;
    region: Region;
    schoolDistricts: SchoolDistrict[] = [];
    emailToConfirm: string = '';

    city: City;
    state: State;
    zipcode: PostalCode;

    suffixes: string[] = ['Jr', 'Sr', 'II', 'III', 'IV', 'V', 'VI'];

    nonMepApplicant: boolean = false;

    signatureString: string = '';

    msg: MsgModel = new MsgModel();

    constructor(private fb: UntypedFormBuilder, private accountRequestService: AccountRequestService, private router: Router, private store: Store<AppState>) {
        this.personalInfoForm = fb.group({
            firstName: ['', [Validators.required]],
            middleInitial: ['', null],
            lastName: ['', [Validators.required]],
            suffix: ['', null],
            workTitle: ['', [Validators.required]],
            workEmail: ['', [Validators.required, Validators.email]],
            confirmWorkEmail: ['', [Validators.required]]
        });

        this.locationForm = fb.group({
            workAddress1: ['', [Validators.required]],
            workAddress2: ['', null],
            workPhoneNumber: ['', [Validators.required]],
            ext: ['', null]
        });

        this.supervisorForm = fb.group({
            supervisorFirstName: ['', null],
            supervisorLastName: ['', null],
            supervisorWorkTitle: ['', null],
            supervisorEmail: ['', null],
            supervisorPhoneNumber: ['', null],
            supervisorExt: ['', null]
        });

        this.accountRequest = new AccountRequest();
        this.selectedMepOrganization = new Organization();
        this.selectedNonMepOrganization = new Organization();
        this.region = new Region();
        this.city = new City();
        this.state = new State();
        this.zipcode = new PostalCode();
    }

    ngOnInit(): void {}

    submit() {
        if (this.checkValid()) {
            this.msg = new MsgModel();
            this.isLoading = true;

            this.accountRequestService
                .create(this.buildAccountRequest(), this.getOrganization(), this.getRegion())
                .pipe()
                .subscribe((res) => {
                    this.msg = res.msg;
                    this.isLoading = false;

                    if (this.msg.SUCCESS) {
                        setTimeout(() => {
                            this.router.navigate(['/login']);
                        }, 5000);
                    } else {
                        this.isLoading = false;
                    }
                });
        } else {
            this.msg = {
                MSG: 'There are errors, please check your input.',
                SUCCESS: false
            };
        }
    }

    checkValid() {
        return (
            this.checkPersonalInfoValid() &&
            this.checkLocationValid() &&
            this.checkRulesOfBehaviorValid() &&
            (this.nonMepApplicant ? this.checkSupervisorValid() : true)
        );
    }

    checkPersonalInfoValid() {
        if (this.getFormValidationErrors(this.personalInfoForm) !== null) {
            return false;
        }

        return true;
    }

    checkLocationValid() {
        if (this.getFormValidationErrors(this.locationForm) !== null) {
            return false;
        }

        if (this.city.ID === undefined) {
            return false;
        }
        if (this.state.ID === undefined) {
            return false;
        }
        if (this.zipcode.ID === undefined) {
            return false;
        }
        if (this.nonMepApplicant) {
            if (this.selectedNonMepOrganization) {
                if (!this.selectedNonMepOrganization.ID!) {
                    return false;
                }
            }
            if (this.getFormValidationErrors(this.supervisorForm) !== null) {
                return false;
            }
        } else {
            if (this.getRegion()?.ID === undefined) {
                return false;
            }
        }

        return true;
    }

    checkRulesOfBehaviorValid() {
        if (this.signatureString ? this.signatureString.length === 0 : true) {
            return false;
        }

        return true;
    }

    checkSupervisorValid() {
        if (this.getFormValidationErrors(this.supervisorForm) !== null) {
            return false;
        }

        return true;
    }

    getFormValidationErrors(form: UntypedFormGroup) {
        if (form) {
            type newObj = { [key: string]: any };

            let res: newObj = {};

            Object.keys(form.controls).forEach((key: string) => {
                let controlErrors: ValidationErrors = <UntypedFormControl>form.get(key)!.errors;
                if (controlErrors != null) {
                    Object.keys(controlErrors).forEach((keyError) => {
                        res[key] = keyError;
                    });
                }
            });

            return Object.keys(res).length === 0 ? null : res;
        } else {
            return null;
        }
    }

    toggleNonMepApplication() {
        if (this.nonMepApplicant) {
            this.supervisorForm.get('supervisorFirstName')?.setValidators([Validators.required]);
            this.supervisorForm.get('supervisorFirstName')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorLastName')?.setValidators([Validators.required]);
            this.supervisorForm.get('supervisorLastName')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorWorkTitle')?.setValidators([Validators.required]);
            this.supervisorForm.get('supervisorWorkTitle')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorEmail')?.setValidators([Validators.required, Validators.email]);
            this.supervisorForm.get('supervisorEmail')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorPhoneNumber')?.setValidators([Validators.required]);
            this.supervisorForm.get('supervisorPhoneNumber')?.updateValueAndValidity();
        } else {
            this.supervisorForm.get('supervisorFirstName')?.setValidators(null);
            this.supervisorForm.get('supervisorFirstName')?.setErrors(null);
            this.supervisorForm.get('supervisorFirstName')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorLastName')?.setValidators(null);
            this.supervisorForm.get('supervisorLastName')?.setErrors(null);
            this.supervisorForm.get('supervisorLastName')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorWorkTitle')?.setValidators(null);
            this.supervisorForm.get('supervisorWorkTitle')?.setErrors(null);
            this.supervisorForm.get('supervisorWorkTitle')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorEmail')?.setValidators(null);
            this.supervisorForm.get('supervisorEmail')?.setErrors(null);
            this.supervisorForm.get('supervisorEmail')?.updateValueAndValidity();

            this.supervisorForm.get('supervisorPhoneNumber')?.setValidators(null);
            this.supervisorForm.get('supervisorPhoneNumber')?.setErrors(null);
            this.supervisorForm.get('supervisorPhoneNumber')?.updateValueAndValidity();
        }
    }

    buildAccountRequest() {
        let newAccountRequest = new AccountRequest();

        newAccountRequest.FIRST_NAME = this.personalInfoForm.get('firstName')?.value;
        newAccountRequest.MIDDLE_INITIAL = this.personalInfoForm.get('middleInitial')?.value;
        newAccountRequest.LAST_NAME = this.personalInfoForm.get('lastName')?.value;
        newAccountRequest.SUFFIX = this.personalInfoForm.get('suffix')?.value;
        newAccountRequest.WORK_TITLE = this.personalInfoForm.get('workTitle')?.value;
        newAccountRequest.EMAIL_ADDRESS = this.personalInfoForm.get('workEmail')?.value;

        newAccountRequest.ADDRESS_LINE_1 = this.locationForm.get('workAddress1')?.value;
        newAccountRequest.ADDRESS_LINE_2 = this.locationForm.get('workAddress2')?.value;
        newAccountRequest.TELEPHONE_NUMBER = this.locationForm.get('workPhoneNumber')?.value;
        newAccountRequest.TELEPHONE_NUMBER_EXT = this.locationForm.get('ext')?.value;

        newAccountRequest.CITIES_ID = this.city.ID;
        newAccountRequest.STATES_ID = this.state.ID;
        newAccountRequest.POSTAL_CODES_ID = this.zipcode.ID;

        if (this.nonMepApplicant) {
            newAccountRequest.SUPERVISOR_FIRST_NAME = this.supervisorForm.get('supervisorFirstName')?.value;
            newAccountRequest.SUPERVISOR_LAST_NAME = this.supervisorForm.get('supervisorLastName')?.value;
            newAccountRequest.SUPERVISOR_WORK_TITLE = this.supervisorForm.get('supervisorWorkTitle')?.value;
            newAccountRequest.SUPERVISOR_EMAIL_ADDRESS = this.supervisorForm.get('supervisorEmail')?.value;
            newAccountRequest.SUPERVISOR_TELEPHONE_NUMBER = this.supervisorForm.get('supervisorPhoneNumber')?.value;
            newAccountRequest.SUPERVISOR_TELEPHONE_NUMBER_EXT = this.supervisorForm.get('supervisorExt')?.value;
        }

        newAccountRequest.SIGNATURE = this.signatureString;

        newAccountRequest.ACCOUNT_REQUEST_SCHOOL_DISTRICTS = this.getAccountRequestSchoolDistricts();

        return newAccountRequest;
    }

    getOrganization() {
        //let organization = this.organization;

        // Test Organization while component is being created
        // California State University, Sacramento
        // organization = {
        //     ID: 20292,
        //     PARTy: {
        //         ID: 12161246
        //     }
        // };
        // Sacramento City Unified
        // organization = {
        //     ID: 292,
        //     PARTy: {
        //         ID: 40230
        //     }
        // };

        if (this.nonMepApplicant) {
            if (this.selectedNonMepOrganization?.ID) {
                return this.selectedNonMepOrganization;
            }
        } else {
            if (this.selectedMepOrganization?.ID) {
                return this.selectedMepOrganization;
            }
        }

        return undefined;
    }

    getRegion() {
        if (this.nonMepApplicant) {
            return undefined;
        } else {
            return this.region;
        }
    }

    getAccountRequestSchoolDistricts() {
        let accountRequestSchoolDistricts: AccountRequestSchoolDistrict[] = [];

        // accountRequestSchoolDistricts.push({ SCHOOL_DISTRICTS_ID: 860 });
        // accountRequestSchoolDistricts.push({ SCHOOL_DISTRICTS_ID: 80 });

        this.schoolDistricts.forEach((sd) => {
            accountRequestSchoolDistricts.push({ SCHOOL_DISTRICTS_ID: sd.ID });
        });

        return accountRequestSchoolDistricts;
    }

    clearMsg() {
        this.msg = new MsgModel();
    }

    // Stepper functions
    goNextPersonalInfo(stepper: MatStepper) {
        if (this.checkPersonalInfoValid()) {
            stepper.next();
        }
    }

    goNextLocation(stepper: MatStepper) {
        if (this.checkLocationValid()) {
            stepper.next();
        }
    }

    goNextRulesOfBehavior(stepper: MatStepper) {
        if (this.checkRulesOfBehaviorValid()) {
            stepper.next();
        }
    }
}
